import { isStageOrDev } from "./useIsStageOrDev";

export const storePagesEnabled = (): boolean =>
  Boolean((window as unknown as { electronAPI?: unknown }).electronAPI) ||
  isStageOrDev();

export const useStorePagesEnabled = storePagesEnabled;
